import { useMutation } from "@apollo/react-hooks";

import addBankDetails from "../graph-ql/addBankDetails.graphql";

const useMutationAddBankDetails = (
  personKey: string,
  accountNumber: string,
  sortCode: string,
  nameOnAccount: string,
  { onCompleted }: { onCompleted: () => void },
  { onError }: { onError: () => void },
) =>
  useMutation(addBankDetails, {
    variables: {
      personKey: personKey,
      accountNumber: accountNumber,
      sortCode: sortCode,
      nameOnAccount: nameOnAccount,
    },
    onCompleted,
    onError,
  });

export default useMutationAddBankDetails;
